import { render } from "./OrderList.vue?vue&type=template&id=c9eb8b54&scoped=true"
import script from "./OrderList.vue?vue&type=script&lang=js"
export * from "./OrderList.vue?vue&type=script&lang=js"

import "./OrderList.vue?vue&type=style&index=0&id=c9eb8b54&scoped=true&lang=css"

import exportComponent from "C:\\Users\\The Knight\\Desktop\\Cashoo\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c9eb8b54"]])

export default __exports__